export enum InternalStatusCode {
  OK = 'ISC200',
  GENERIC_EXCEPTION = 'ISC300',
  TRIAD_EXCEPTION = 'ISC400',
  CREATE_APPOINTMENT_HOUR_LIMIT = 'ISC402',
  COVERAGE_EXCEPTION = 'ISC500',
  MULTIPLE_APPOINTMENTS_EXCEPTION = 'ISC600',
  VALIDATION_EXCEPTION = 'ISC700',
  GET_MEDICAL_RECORD_EXCEPTION = 'ISC800',
  GET_MCIID_EXCEPTION = 'ISC801',
  AUTH_SALESFORCE_EXCEPTION = 'ISC900',
  GET_SLOTS_EXCEPTION = 'ISC901',
  CREATE_SERVICE_APPOINTMENT_EXCEPTION = 'ISC902',
  UPDATE_SERVICE_APPOINTMENT_EXCEPTION = 'ISC903',
  CONFIRM_SERVICE_APPOINTMENT_EXCEPTION = 'ISC904',
  GET_PATIENT_EXCEPTION = 'ISC905',
  DB_SAVE_DATA_EXCEPTION = 'ISC1000',
  DB_GET_DATA_EXCEPTION = 'ISC1001',
  SEND_EMAIL_EXCEPTION = 'ISC1100',
  CORE_AUTHENTICATION_EXCEPTION = 'ISC1010',
  RETURN_APPOINTMENTS_EXCEPTION = 'ISC651',
  FIRST_APPOINTMENT_EXCEPTION = 'ISC650',
  FIRST_APPOINTMENT_UNAVAILABLE_EXCEPTION = 'ISC651',
  RETURN_APPOINTMENT_UNAVAILABLE_EXCEPTION = 'ISC652',
  INTERVAL_AFTER_FIRST_APPOINTMENT_EXCEPTION = 'ISC653',
  MEDICAL_RECORD_EXCEPTION = 'PRT01'
}
